import React from "react";
import { Check } from "lucide-react";
import { Button } from "./ui/button";
import { brands } from "../mock";

const About = () => {
  const points = [
    "Eigen vakman – geen onderaannemers",
    "Werken met A-merk verven (Sikkens, Flexa, Wijzonol)",
    "Meubels en vloeren altijd netjes afgedekt",
    "Vooraf duidelijke prijs, geen meerwerk-verrassingen",
  ];

  return (
    <section id="werkwijze" className="py-20 lg:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-xl ring-1 ring-slate-200">
              <img
                src="https://images.unsplash.com/photo-1674485190969-4347f72aad0e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxzcHJheSUyMGd1biUyMHBhaW50aW5nfGVufDB8fHx8MTc4MTc5NjYxOHww&ixlib=rb-4.1.0&q=85"
                alt="Professionele latex spuiter aan het werk"
                className="w-full h-[500px] object-cover"
              />
            </div>
            <div className="absolute -bottom-8 -right-4 sm:right-8 bg-white rounded-2xl shadow-xl p-5 ring-1 ring-slate-100 max-w-[260px]">
              <div className="text-xs uppercase tracking-wide text-slate-500 font-semibold">
                Vanaf prijs
              </div>
              <div className="mt-1 text-3xl font-extrabold text-slate-900">
                € 3,-<span className="text-base text-slate-500 font-medium"> / m²</span>
              </div>
              <div className="text-xs text-slate-600 mt-1">
                Eerlijke prijs op maat per project
              </div>
            </div>
          </div>

          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-100 text-slate-800 text-xs font-semibold mb-4 border border-yellow-200">
              Over DK Latex Spuiten
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight text-balance">
              25+ jaar specialist in strak spuitwerk.
            </h2>
            <p className="mt-5 text-lg text-slate-600 leading-relaxed">
              Wij onderscheiden ons door super strak spuitwerk en een eerlijke,
              transparante manier van werken. Geen verrassingen achteraf, wel een
              resultaat waar u jarenlang plezier van heeft.
            </p>

            <ul className="mt-6 space-y-3">
              {points.map((p) => (
                <li key={p} className="flex items-start gap-3">
                  <span className="w-6 h-6 rounded-full bg-yellow-400 flex items-center justify-center shrink-0 mt-0.5">
                    <Check className="w-3.5 h-3.5 text-slate-900" strokeWidth={3} />
                  </span>
                  <span className="text-slate-700">{p}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8">
              <Button asChild size="lg" className="bg-slate-900 hover:bg-slate-800 text-white font-semibold">
                <a href="#contact">Plan een vrijblijvend gesprek</a>
              </Button>
            </div>

            <div className="mt-10 pt-8 border-t border-slate-200">
              <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold mb-3">
                Wij werken met o.a.
              </div>
              <div className="flex flex-wrap items-center gap-x-8 gap-y-2">
                {brands.map((b) => (
                  <span key={b} className="text-lg font-bold text-slate-400 hover:text-slate-700 transition-colors">
                    {b}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
